import {ContainerFacade} from '@igp/shared/ioc-container';
import type {IEpicsBuilder} from '@igp/shared/redux';
import type {IEntityReadService} from '@igp/shared/redux/entity';
import type {EntityType} from '@models';

import {boUserServiceTypes} from './constants';
import {BoUserEpicsBuilder} from './epics';
import {BoUserService} from './service';

export class BoUserContainerFacade extends ContainerFacade {
    bindAll() {
        this._container.bind<IEntityReadService<EntityType>>(boUserServiceTypes.service).to(BoUserService);
        this._container.bind<IEpicsBuilder>(boUserServiceTypes.epicsBuilder).to(BoUserEpicsBuilder);
    }
}
